// Global DOM Components.
import React from 'react'
import { Button, TextField } from '@mui/material'

// App Language.
import { useTranslation } from 'react-i18next'

function FromToFilter(props) {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  return (
    <div className={`${props.page}-page__filters-${props.field}-wrapper`}>
      <div className="filter-wrapper">
        <label htmlFor={`${props.page}-page__filters-${props.field}-from`}>{props.fromLabel}</label>
        <TextField
          name={`${props.page}-page__filters-${props.field}-from`}
          className={`${props.page}-page__filters-${props.field}-from`}
          fullWidth={true}
          value={props.fromValue || ''}
          placeholder={i18n.language == 'fr' ? '0$' : '$0'}
          onChange={e => props.onChange(e, 'medianGiftMin')}
        />
      </div>
      <div className="filter-connector-wrapper">
        <span>{t.funder.to}</span>
      </div>
      <div className="filter-wrapper">
        <label htmlFor={`${props.page}-page__filters-${props.field}-to`}>{props.toLabel}</label>
        <TextField
          name={`${props.page}-page__filters-${props.field}-to`}
          className={`${props.page}-page__filters-${props.field}-to`}
          fullWidth={true}
          value={props.toValue || ''}
          placeholder={`$ ${t.facets.unlimited}`}
          onChange={e => props.onChange(e, 'medianGiftMax')}
        />
      </div>
      {props.showActions && (
        <div className={`${props.page}-page__filters-actions`}>
          <Button className={`${props.page}-page__filters-button-submit`} onClick={props.onSubmit}>
            {t.global.submit}
          </Button>
        </div>
      )}
      {props.showClear && (
        <div className={`${props.page}-page__filters-actions`}>
          <Button className={`${props.page}-page__filters-button-clear`} onClick={props.onCancel}>
            {t.global.clear}
          </Button>
        </div>
      )}
    </div>
  )
}

export default FromToFilter
